import { render } from "./BalLink.vue?vue&type=template&id=870c55fa"
import script from "./BalLink.vue?vue&type=script&lang=js"
export * from "./BalLink.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jason/u/acsi-ui-balancer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__